<template>
  <div class="crews">
    <toolbar
      backRoute="/dashboard"
      title="Crew"
      :addButton="true"
      addButtonLabel="Add crew"
      addButtonRoute="/dashboard/crews/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search crews"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="last_name" view="crews" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <sortable-table-heading field="birth_date" view="crews" :column="orderColumn" :direction="orderDirection">DOB</sortable-table-heading>
          <sortable-table-heading field="email" view="crews" :column="orderColumn" :direction="orderDirection">Email</sortable-table-heading>
          <sortable-table-heading field="phone" view="crews" :column="orderColumn" :direction="orderDirection">Phone</sortable-table-heading>
          <sortable-table-heading field="warnings_count" view="crews" :column="orderColumn" :direction="orderDirection">Warnings</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="6"
            class="text-center">
            Loading crews&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && crews.length === 0">
            <td
              colspan="6"
              class="text-center">
              There are no crews to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(crew, index) of crews"
          :key="'crew-' + index">
          <td class="align-middle">{{ crew.first_name }} {{ crew.last_name }}</td>
          <td class="align-middle" style="width: 140px;">{{ crew.birth_date | formatDateToUK }}</td>
          <td class="align-middle" style="width: 160px;"><a :href="'mailto:' + crew.email"><small>{{ crew.email }}</small></a></td>
          <td class="align-middle" style="width: 160px;"><a :href="'tel:' + crew.phone"><small>{{ crew.phone }}</small></a></td>
          <td class="align-middle text-center" style="width: 140px;">
            <span class="text-warning" v-if="crew.warnings_count > 0">{{ crew.warnings_count }}</span>
            <span class="text-light" v-else>{{ crew.warnings_count }}</span>
          </td>
          <td class="align-middle" style="width: 140px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/crews/' + crew.id)"
              class="mr-2"
              title="Edit crew">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeCrew(crew.id)"
              title="Remove crew">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'crews',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  filters: {
    formatDateToUK (input) {
      if (!input) {
        return '';
      }

      return input.split('-').reverse().join(' / ');
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      crews: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeCrew (crewID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/crews/delete/',
        id: crewID,
        successTitle: 'Crew removed',
        successText: 'The selected crew has been removed',
        confirmTitle: 'Do you really want to remove this crew?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
